const initialState = {
  courses: [],
  params: {},
  totalCourses: 0,
  courseDetail: {},
  transactionCourseUser: {},
  transactionCourseUserAddress: {},
  universityOptionSelect: [],
};

const courseReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_COURSE_IN_HOUSE_COURSES":
      return {
        ...state,
        courses: (action.data.courses ? action.data.courses : state.courses),
        params: {...state.params, ...action.params},
        totalCourses: (action.data.totalCourses ? action.data.totalCourses : state.totalCourses),
      };
    case "GET_COURSE_IN_HOUSE_COURSE_DETAIL":
      return {
        ...state,
        courseDetail: action.data.courseDetail,
        transactionCourseUser: action.data.transactionCourseUser,
        transactionCourseUserAddress: action.data.transactionCourseUserAddress,
      };
    case "SAVE_COURSE_IN_HOUSE_COURSE_REGISTRATION":
      return {
        ...state,
        courseDetail: action.data.courseDetail,
        transactionCourseUser: action.data.transactionCourseUser,
        transactionCourseUserAddress: action.data.transactionCourseUserAddress,
      };
    case "GET_COURSE_IN_HOUSE_COURSE_INITIAL":
      return {
        ...state,
        universityOptionSelect: action.data.universityOptionSelect,
      };
    default:
      return state;
  }
};

export default courseReducer;
